import * as Yup from 'yup'

export const CampaignFolderSchema = Yup.object().shape({
  name: Yup.string().required('This field is required.')
});
